import { atom, reatomAsync } from "@reatom/framework";
import { feedback, getFeedback } from "@/core/api/requests/feedback";
import { AllFeedback } from "./types";

export const feedbackAtom = atom<AllFeedback | null>(null, "feedbackAtom");

export const isLoadingFeedbackAtom = atom<boolean>(
  false,
  "isLoadingFeedbackAtom"
);

export const createFeedbackAction = reatomAsync(
  async (
    _ctx,
    {
      oid,
      rating,
      text,
    }: { oid: number; rating: "positive" | "negative"; text: string }
  ) => {
    const response = await feedback(oid, rating, text);
    return response;
  },
  {
    name: "createFeedbackAction",
  }
);

export const getFeedbackAction = reatomAsync(
  async (ctx, oid: number) => {
    isLoadingFeedbackAtom(ctx, true);
    const response = await getFeedback(oid);
    return response;
  },
  {
    name: "getFeedbackAction",
    onFulfill: (ctx, response) => {
      feedbackAtom(ctx, response);
      isLoadingFeedbackAtom(ctx, false);
    },
    onReject: (ctx) => {
      isLoadingFeedbackAtom(ctx, false);
    },
  }
);
